import { render, staticRenderFns } from "./BlockObject.vue?vue&type=template&id=00ba0bea&scoped=true"
import script from "./BlockObject.vue?vue&type=script&lang=js"
export * from "./BlockObject.vue?vue&type=script&lang=js"
import style0 from "./BlockObject.vue?vue&type=style&index=0&id=00ba0bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ba0bea",
  null
  
)

export default component.exports